function handleclick(){
    window.open("https://drive.google.com/file/d/1tJENIGy6jhHTmtgVx9AguXfgVGCDvG9C/view?usp=sharing")
  window.location.href='https://drive.google.com/uc?export=download&id=1tJENIGy6jhHTmtgVx9AguXfgVGCDvG9C'
}
export default handleclick